import { useContext } from "react";
import { SettingsContext } from "context/SettingsContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faSquareInstagram,
  faLinkedin,
  faSquareXTwitter,
  faSquareThreads,
  faSquarePinterest,
} from "@fortawesome/free-brands-svg-icons";
import NanLogo from "components/General/Icons/NanLogo";
import { printHTML } from "hooks/utils/formatter";

const SOCIAL_ICON_MAP = {
  facebook: faSquareFacebook,
  instagram: faSquareInstagram,
  linkedin: faLinkedin,
  twitter: faSquareXTwitter,
  threads: faSquareThreads,
  pinterest: faSquarePinterest,
};

const Footer = () => {
  const { settings } = useContext(SettingsContext);
  const year = new Date().getFullYear();
  const columns = settings?.options?.footer_kolommen || [];

  return (
    <footer className="w-full py-8 md:py-20 bg-footer">
      <div className="px-4 mx-auto max-w-app">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-10 md:gap-y-14">
          {columns.map((column, idx) => {
            const { kolom_titel, kolom_inhoud, socials, inhoud_en_socials_omdraaien } = column || {};

            return (
              <div key={idx}>
                {kolom_titel && (
                  <h4 className="mb-3">
                    <span className="text-lg font-bold leading-8 text-footer-text">
                      {kolom_titel}
                    </span>
                  </h4>
                )}

                <div className={`flex flex-col gap-8 ${inhoud_en_socials_omdraaien ? "flex-col-reverse" : ""}`}>
                  {typeof kolom_inhoud === "string" && (
                    <div className="overflow-hidden leading-6 break-words text-13 md:text-sm md:leading-7 text-footer-text">
                      {printHTML(kolom_inhoud)}
                    </div>
                  )}

                  {Array.isArray(socials) &&
                    <div>
                      {socials?.map((social, i) => {
                        const key = (social?.selecteer_soort || "").toLowerCase();
                        const icon = SOCIAL_ICON_MAP[key];
                        const href = social?.link?.url;
                        if (!icon || !href) return null;

                        const label =
                          (social?.link?.title || "").trim() ||
                          href.replace(/^https?:\/\//, "").replace(/\/$/, "");

                        const target = social?.link?.target || "_blank";

                        return (
                          <a
                            key={`social-${i}`}
                            title={label}
                            href={href}
                            target={target}
                            rel="noopener noreferrer"
                            className="flex items-center gap-4 mb-2"
                          >
                            <FontAwesomeIcon icon={icon} className="text-2xl text-primary" />
                            <span className="text-sm underline text-footer-text">{label}</span>
                          </a>
                        );
                      })}
                    </div>
                  }
                </div>
              </div>
            )
          })}
        </div>

        <div className="flex items-center justify-between mt-10">
          <div>
            <span className="text-sm text-footer-text">Copyright {year}</span>
          </div>
          <a
            href="https://notanumber.digital/"
            title="Not a number"
            target="_blank"
            rel="noreferrer"
          >
            <div className="w-auto h-6">
              <NanLogo />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
